import Input from './input';
import mapProps from '../scripts/utils/map-props';

export default mapProps([
  'value',
  {
    name: 'clearable',
    alias: ['allowClear'],
  },
])(Input);
